exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".supportList > li {\n  background-color: transparent;\n  padding: 4px;\n}\n.support {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid var(--gray-lighter);\n  padding: 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n.support img {\n  padding: 10px;\n  height: 80px;\n  width: 80px;\n}\n.support > div {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);

// exports
